// src/guide/guide.js
import { guide_compte_contrats } from "@/guide/compte/guide_compte_contrats";
import { guide_changement_machine } from "./compte/guide_changement_machine";
import { guide_compte_coordonnees } from "@/guide/compte/guide_compte_coordonnees";
import { guide_modifier_infos } from "./compte/guide_modifier_infos";
import { guide_modifier_mail } from "./compte/guide_modifier_mail";
import { guide_modifier_mdp } from "./compte/guide_modifier_mdp";
import { guide_compte_factures } from "@/guide/compte/guide_compte_factures";
import { guide_compte_licences } from "@/guide/compte/guide_compte_licences";
import { guide_compte_utilisateurs } from "@/guide/compte/guide_compte_utilisateurs";
import { guide_compte_creer_utilisateurs } from "./compte/guide_compte_creer_utilisateur";
import { guide_tickets } from "@/guide/tickets/guide_tickets";
import { guide_creer_ticket } from "./tickets/guide_creer_ticket";
import { guide_voir_ticket } from "./tickets/guide_voir_ticket";
import { guide_commenter } from "./compte/guide_commenter";
import { guide_telechargements } from "./telechargements/guide_telechargements";
import { guide_forums } from "./forums/guide_forums";
import { guide_creer_forum } from "./forums/guide_creer_forum";
import { guide_fiches_techniques } from "./fiches_techniques/guide_fiches_techniques";
import { guide_selection_tiers } from "./selection_tiers/guide_selection_tiers";
import { guide_mes_services_ia } from "./ia/guide_mes_services_ia";
import { guide_nouvelle_generation_ia } from "./ia/guide_nouvelle_generation_ia";

const guideMethods = {
  compte_contrats: guide_compte_contrats,
  changement_machine: guide_changement_machine,
  compte_coordonnees: guide_compte_coordonnees,
  compte_modifier_infos: guide_modifier_infos,
  compte_modifier_mail: guide_modifier_mail,
  compte_modifier_mdp: guide_modifier_mdp,
  compte_factures: guide_compte_factures,
  compte_licences: guide_compte_licences,
  compte_utilisateurs: guide_compte_utilisateurs,
  compte_creer_utilisateurs: guide_compte_creer_utilisateurs,
  tickets: guide_tickets,
  creer_ticket: guide_creer_ticket,
  voir_ticket: guide_voir_ticket,
  commenter: guide_commenter,
  telechargements: guide_telechargements,
  forums: guide_forums,
  creer_forum: guide_creer_forum,
  fiches_techniques: guide_fiches_techniques,
  selection_tiers: guide_selection_tiers,
  mes_services_ia: guide_mes_services_ia,
  nouvelle_generation_ia: guide_nouvelle_generation_ia,
};

// Désactiver les flèches directionnelles uniquement lorsque le guide est actif
// const disableArrowKeys = (event) => {
//   if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(event.key)) {
//     event.preventDefault();
//     event.stopImmediatePropagation(); // Empêche toute autre gestion de l'événement
//   }
// };

export async function startTour(context, translations) {
  // document.addEventListener("keydown", disableArrowKeys, true);
  // 'context' doit être une chaîne simple : 'generale', 'requete', etc.
  const guideMethod = guideMethods[context];
  if (guideMethod) {
    guideMethod(translations);
  } else {
    console.error("Aucun guide trouvé pour le contexte :", context);
  }

  // window.addEventListener("keydown", disableArrowKeys, true);
}
